import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { PatientService } from 'src/app/services/patient/patient.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { environment } from 'src/environments/environment';

interface PatientTableDisplay {
  patientData: string;
  id: string;
  meta: ResultatPatient;
}

interface SelectPatient {
  doSelect: boolean;
  patientId: string;
}

@Component({
  selector: 'app-modal-patients-to-see-in-meeting',
  templateUrl: './modal-patients-to-see-in-meeting.component.html',
  styleUrls: [
    './modal-patients-to-see-in-meeting.component.scss',
    '../../fragments/modal/modal.fragment.scss'
  ]
})
export class ModalPatientsToSeeInMeetingComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public patientsTable: Paginated<PatientTableDisplay>;
  public patientsTableColumn = [
    { title: 'Patients', data: 'patientData' }
  ];
  public selectedPatients: Array<PatientTableDisplay> = [];

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _patientSrv: PatientService
  ) { }

  async ngOnInit(): Promise<void> {
    await this._initData();
  }

  public closeModal(returnPatients = false): void {
    const patients: Array<ResultatPatient> = [];
    if (returnPatients && this.selectedPatients.length > 0) {
      for (const sp of this.selectedPatients) {
        patients.push(sp.meta);
      }
    }

    this.closeEmitter.emit(patients.length > 0 ? patients : undefined);
  }

  public addRemovePatient(event: PatientTableDisplay): void {
    if (!this.selectedPatients.includes(event)) {
      this._doSelectPatient({ doSelect: true, patientId: event.id });
      this.selectedPatients.push(event);
    } else {
      this._doSelectPatient({ doSelect: false, patientId: event.id });
      const index = this.selectedPatients.findIndex(e => e.id === event.id);
      this.selectedPatients.splice(index, 1);
    }
  }

  private async _initData(): Promise<void> {
    const patients = await this._patientSrv.patientsSearchFilters({
      getArchive: false,
      isAVoirEnReunion: true
    });

    for (const p of patients.objects) {
      this._addPatientToDisplayTable(p);
    }
  }

  private _addPatientToDisplayTable(patient: ResultatPatient): void {
    const patientTableDisplay: PatientTableDisplay = {
      id: patient.id,
      meta: patient,
      patientData: patient.nomPrenomDateNaissance
    };

    if (this.patientsTable) {
      this.patientsTable.objects.push(patientTableDisplay);
    } else {
      this.patientsTable = {
        objects: [patientTableDisplay],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private _doSelectPatient(patient: SelectPatient): void {
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      const index = this.patientsTable.objects.findIndex(p => p.id === patient.patientId);
      const patientDisplayTable = this.patientsTable.objects.find(p => p.id === patient.patientId);

      if (patient.doSelect) {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'black' });
      }

      this.patientsTable.objects.splice(index, 1, patientDisplayTable);
    }
  }

}
